<section>
  @if (isLoading$ | async) {
    <div class="loading-indicator">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  }

  @if (user$ | async; as user) {
    <div class="widget-header gap-2">
      <div class="user-info">
        <h1 class="text-wrap">
          Welcome
          {{ user.FirstName }} {{ user.LastName }}
        </h1>

        @if (user.Title) {
          <div class="contact-title">{{ user.Title }}</div>
        }
        @if (user.Phone || user.Email) {
          <div class="contact-info">
            @if (user.Phone) {
              {{ user.Phone | phoneNumber: 'US' }} |
            }
            {{ user.Email }}
          </div>
        }
      </div>

      <div class="noc-info min-w-[243px]">
        <div class="noc-tag">For 24/7 Support</div>
        <a class="open-ticket-link" href="/tickets">Open a ticket</a>
        <span class="noc-tag"> or </span>
        <a
          class="contact-us-link"
          href="https://www.nitelusa.com/support/"
          target="_blank"
          >Contact us</a
        >
      </div>
    </div>

    <div class="summary-content">
      <div class="billing-address">
        <div class="company-title">{{ user.Account.Name }}</div>
        <div class="address-label">Billing Address</div>
        <div class="address-wrapper">
          <div class="custom-icon location_dark">location icon</div>
          {{ user.Account.BillingAddress.street }}<br />
          {{ user.Account.BillingAddress.city }},
          {{ user.Account.BillingAddress.stateCode }}
          {{ user.Account.BillingAddress.postalCode }}
        </div>
      </div>

      @if (user.Account?.Account_Manager__r) {
        <div class="account-manager">
          <div class="manager-title">Account Manager</div>
          <div class="manager-wrapper">
            <div class="manager-name">
              {{ user.Account.Account_Manager__r.Name }}
            </div>
            @if (user.Account.Account_Manager__r.Email) {
              <div class="manager-email">
                <div class="custom-icon email_dark">email icon</div>
                <a href="mailto:{{ user.Account.Account_Manager__r.Email }}">{{
                  user.Account.Account_Manager__r.Email
                }}</a>
              </div>
            }
            @if (user.Account.Account_Manager__r.Phone) {
              <div class="manager-phone">
                <div class="custom-icon phone_dark">phone icon</div>
                <a href="tel:{{ user.Account.Account_Manager__r.Phone }}">{{
                  user.Account.Account_Manager__r.Phone
                }}</a>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</section>
